import EndDot from '@elements/EndDot'
import styled from '@emotion/styled'

import { CircularProgress } from '@mui/material'
import { size } from '@styles/theme'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 6rem;
`

const FeedFooter = ({ context }) => {
  const { posts, postsLoaded } = context
  const isHidden = (!posts || posts?.length === 0)


  const renderContents = () => {
    if (isHidden) return;
    else if (posts?.length > 0 && postsLoaded) return (
      <EndDot />
    );
    else if (posts?.length > 0 && !postsLoaded) return (
      <CircularProgress
        size={size(4)}
        style={{
          color: '#6A23FF',
          visibility: isHidden ? 'hidden' : 'visible'
        }}
        thickness={8}
      />
    )
  }


  return (
    <Container>
      {renderContents()}
    </Container>
  )
}

export { FeedFooter }
